const INITIAL_STATE = {
  data: {},
  errors: {}
}
		
const getExportReportsCsv = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'LOADED_EXPORT_REPORT':
    return { ...state, ...INITIAL_STATE, loaderExport:false }
  default:
    return state
}
}
		
export default getExportReportsCsv;